import { v4 } from 'uuid';

import { Event, EventEnvelop, EventStore } from '@/base/domains';

export class InMemoryEventStore implements EventStore {
  save<E extends Event>(_: EventEnvelop<E>): Promise<string> {
    return Promise.resolve(v4());
  }
}
